
import { defineComponent } from "vue";
export default defineComponent({
  name: "UrlLink",
  props: {
    model: {
      type: String,
      required: true,
    },
  },
});
